module.exports = __webpack_public_path__ + "img/bg.2e1f0462.png";